import React, { useState, useEffect } from "react";
import { awsUrl2 } from "../../../config";
import { Auth } from "../../../utils/amplifyAuth";
import axios from "axios";
import SmallLoader from "../../../newcomponent/common/smallLoader";
import { isExistingBusiness, hasNewAddition } from "../../../utils/fieldAccess";

// Define the component
const DownloadEAcord = (props) => {
  // State declaration using useState hook
  const { selectedCarrier, stateTableData, updatePopUpData, disabledDropDown } =
    props;
  const states = Object.keys(stateTableData);
  const [loadingEAcordNCCI, setLoadingEAcordNCCI] = useState(false);
  const [loadingEAcordCA, setLoadingEAcordCA] = useState(false);
  const [loadingEAcordFL, setLoadingEAcordFL] = useState(false);
  const [activeSubMenu, setActiveSubMenu] = useState(null);

  const not_include_in_ncci = ["oh", "wa", "wy", "nd", "fl", "ca"];
  const [statesMap, setStatesMap] = useState({
    ncci: {
      available: false,
      stateList: [],
    },
    ca: {
      available: false,
      stateList: [],
    },
    fl: {
      available: false,
      stateList: [],
    },
  });

  const currProspect = JSON.parse(sessionStorage.getItem("currProspect") || "{}");

  const hasNewCodesForAcordType = (acordType) => {
    if (!isExistingBusiness()) return false;
    const locations = Object.values(currProspect?.childrenLoc || {});

    return locations.some((loc) => {
      const locState = (loc?.state?.value || "").toLowerCase();

      let belongsToAcordType = false;
      if (acordType === "ca") {
        belongsToAcordType = locState === "ca";
      } else if (acordType === "fl") {
        belongsToAcordType = locState === "fl";
      } else if (acordType === "ncci") {
        belongsToAcordType =
          locState !== "" && !not_include_in_ncci.includes(locState);
      }

      return belongsToAcordType && hasNewAddition(loc);
    });
  };

  useEffect(() => {
    const result = JSON.parse(JSON.stringify(statesMap));
    states.forEach((state) => {
      switch (state) {
        case "ca":
          result.ca.stateList.push(state.toUpperCase());
          result.ca.available = true;
          break;
        case "fl":
          result.fl.stateList.push(state.toUpperCase());
          result.fl.available = true;
          break;
        default:
          if (!not_include_in_ncci.includes(state)) {
            result.ncci.stateList.push(state.toUpperCase());
            result.ncci.available = true;
          }
          break;
      }
    });
    console.log("setStatesMap", states, result);
    setStatesMap(result);
  }, [stateTableData, selectedCarrier]);

  const handleDownloadPopup = async (acordType, scope = "All") => {
    updatePopUpData({
      show: true,
      title: "Note",
      children: (
        <>
          <br></br>
          <span style={{ fontWeight: "bold" }}>
            Eacord may not work as intended in other browsers. For the best
            experience, please use Google Chrome.
          </span>
        </>
      ),
      acceptBtn: "Ok",
      acceptBtnCallback: async () => {
        try {
          // setEAcordDisabled(true);
          await downloadEAcord(acordType, scope);
          // setEAcordDisabled(false);
        } catch (error) {
          console.log("error: ", error);
          // setEAcordDisabled(false);
        }
      },
      disableNoButton: true,
    });
  };
  /**
   * Helper: Polls the status API until the PDF is ready or fails
   */
  const pollStatus = async (uuid) => {
    const pollInterval = 3000; // 3 seconds
    const maxAttempts = 20; // 1 minute timeout
    let attempts = 0;

    return new Promise((resolve, reject) => {
      const interval = setInterval(async () => {
        attempts++;
        try {
          // Calling your new pollEAcordRequest endpoint
          // const response = await axios.post(
          //   `http://localhost:3000/dev/api/pollEAcordStatus`,
          //   { uuid },
          // );
          const response = await axios.post(`${awsUrl2}/api/pollEAcordStatus`, {
            uuid,
          });

          const { status, signedUrl } = response.data;

          console.log(`Polling status: ${status} (Attempt ${attempts})`);

          if (status === "completed") {
            clearInterval(interval);
            resolve(signedUrl);
          } else if (status === "failed") {
            clearInterval(interval);
            reject(new Error("PDF generation failed on server."));
          } else if (attempts >= maxAttempts) {
            clearInterval(interval);
            reject(new Error("Polling timed out."));
          }
        } catch (err) {
          console.error("Error during status poll:", err);
          // We don't clear interval here in case of temporary network flicker
        }
      }, pollInterval);
    });
  };

  /**
   * Main Function: Updates state, initiates request, and manages polling
   */
  const downloadEAcord = async (acordType, scope = "All") => {
    // 1. Set Loading States
    if (acordType === "ca") setLoadingEAcordCA(true);
    if (acordType === "ncci") setLoadingEAcordNCCI(true);
    if (acordType === "fl") setLoadingEAcordFL(true);

    try {
      // 2. Data Preparation
      let quoteData = JSON.parse(sessionStorage.getItem("quoteData"));
      let isLoggedIn = await Auth.currentAuthenticatedUser();
      let emailID = isLoggedIn.attributes.email;
      let address = sessionStorage.getItem("address");
      const carrier = selectedCarrier;
      let currProspectDetails = JSON.parse(
        sessionStorage.getItem("currProspect"),
      );

      let etQuoteDetails = {
        email: sessionStorage.getItem("user_id"),
        timestamp: quoteData.date,
        carrier,
        mail_address: "",
        address: address,
        state: statesMap[acordType].stateList,
        peo: currProspectDetails?.peoDetails?.selectedPeo,
        selectedKey: props.selectedPeo || currProspectDetails?.peoDetails?.selectedPeo,
        scope: scope,
        classCodeScope: scope,
        producerDetails: {
          producerName:
            currProspectDetails?.["companyProfile"]?.["producer"]?.["value"] ||
            "Paul Hughes",
          producerEmail: emailID,
          producerFax: " ",
          producerPhone: " ",
          producerMobile: " ",
        },
      };

      console.log("etQuoteDetails", etQuoteDetails);

      // 3. Initiate Request
      // This hits your 'inititateEAcordRequest' Lambda
      // const initRes = await axios.post(
      //   `http://localhost:3000/dev/api/generateEAcord${acordType.toUpperCase()}`,
      //   JSON.stringify(etQuoteDetails),
      // );

      const initRes = await axios.post(
        `${awsUrl2}/api/generateEAcord${acordType.toUpperCase()}`,
        JSON.stringify(etQuoteDetails),
      );

      const { uuid } = initRes.data;
      console.log("Received UUID from initiation response:", uuid);
      if (!uuid) throw new Error("Did not receive UUID from server.");

      // 4. Poll for completion
      const signedUrl = await pollStatus(uuid);

      // 5. Trigger Download
      const filename = `editable_acord_${acordType.toUpperCase()}_${carrier}.pdf`;
      const response = await fetch(signedUrl);
      const blob = await response.blob();

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // 6. Cleanup (Optional: deletes from S3 after download)
      await axios.delete(`${awsUrl2}/api/deleteEAcord?url=${signedUrl}`);
    } catch (error) {
      console.error("E-Acord Flow Error:", error);
      alert(`Could not generate PDF: ${error.message}`);
    } finally {
      // 7. Reset Loading States
      if (acordType === "ca") setLoadingEAcordCA(false);
      if (acordType === "ncci") setLoadingEAcordNCCI(false);
      if (acordType === "fl") setLoadingEAcordFL(false);
    }
  };

  const renderSubMenu = (acordType, label, loading) => {
    return (
      <li
        key={acordType}
        className="eacord-submenu-container"
        onMouseEnter={() => setActiveSubMenu(acordType)}
        onMouseLeave={() => setActiveSubMenu(null)}
      >
        <div
          className="dropdown-item eacord-submenu-trigger"
          onClick={(e) => {
            e.stopPropagation();
            setActiveSubMenu((prev) => (prev === acordType ? null : acordType));
          }}
        >
          <span>{loading ? `Downloading ${label}...` : label}</span>
          <span style={{ fontSize: "10px", marginLeft: "12px", color: "#555" }}>
            &#9658;
          </span>
        </div>

        {activeSubMenu === acordType && (
          <ul className="dropdown-menu show eacord-submenu">
            {hasNewCodesForAcordType(acordType) && (
              <li>
                <a
                  className="dropdown-item"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveSubMenu(null);
                    handleDownloadPopup(acordType, "Current");
                  }}
                >
                  Current
                </a>
              </li>
            )}
            <li>
              <a
                className="dropdown-item"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveSubMenu(null);
                  handleDownloadPopup(acordType, "All");
                }}
              >
                All
              </a>
            </li>
          </ul>
        )}
      </li>
    );
  };

  // Component JSX
  return (
    <>
      {/* <h1>Hello, World!</h1> */}
      <div className="btnAlignDow">
        <div className="btn-group d-flex justify-content-center align-items-center">
          <button
            type="button"
            className="btn dropdown-toggle download-dropdown"
            data-bs-toggle="dropdown"
            data-bs-display="static"
            aria-expanded="false"
            disabled={disabledDropDown}
          >
            Download EAcord
          </button>
          <ul className="dropdown-menu">
            {statesMap["ncci"].available &&
              renderSubMenu(
                "ncci",
                "NCCI E-Acord",
                loadingEAcordNCCI,
              )}
            {statesMap["ca"].available &&
              renderSubMenu(
                "ca",
                "CA E-Acord",
                loadingEAcordCA,
              )}
            {statesMap["fl"].available &&
              renderSubMenu(
                "fl",
                "FL E-Acord",
                loadingEAcordFL,
              )}
          </ul>
          {(loadingEAcordNCCI || loadingEAcordCA || loadingEAcordFL) && (
            <span className="eAcordLoader">
              <SmallLoader />
            </span>
          )}
        </div>
      </div>
    </>
  );
};

// Export the memoized component
export default React.memo(DownloadEAcord);
